import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

const Dashboard = () => {
    const [name, setName] = useState('');
    const [loading, setLoading] = useState(true);
    const [greeting, setGreeting] = useState('');
    const navigate = useNavigate();

    // Fetch user name
    useEffect(() => {
        fetchUserName();
    }, []);

    const fetchUserName = async () => {
        try {
            const userRef = doc(db, 'user', String(localStorage.getItem('mobile')));
            const userSnap = await getDoc(userRef);

            if (userSnap.exists()) {
                setName(userSnap.data().name?.split(" ")[0] || 'User');
            } else {
                setName('User');
            }
        } catch (error) {
            console.error('Error fetching user name:', error);
            setName('User');
        } finally {
            setLoading(false);
        }
    };

    // Dynamic greeting
    useEffect(() => {
        const hour = new Date().getHours();
        if (hour < 12) setGreeting('Good Morning');
        else if (hour < 17) setGreeting('Good Afternoon');
        else setGreeting('Good Evening');
    }, []);

    const welcomeMessage = greeting && name ? `${greeting}, ${name}! 👋` : 'Welcome! 👋';

    const subjects = [
        {
            title: 'English',
            icon: '/english.png',
            color: '#8b5cf6',
            bgColor: '#f3e8ff',
            path: '/subject/english'
        },
        {
            title: 'Mathematics',
            icon: '/math.png',
            color: '#3b82f6',
            bgColor: '#eff6ff',
            path: '/subject/mathematics'
        },
        {
            title: 'General Knowledge',
            icon: '/gk.png',
            color: '#10b981',
            bgColor: '#ecfdf5',
            path: '/subject/gk'
        },
        {
            title: 'Mental Ability',
            icon: '/reasoning.png',
            color: '#f59e0b',
            bgColor: '#fffbeb',
            path: '/subject/reasoning'
        },

    ];

    const handleSubjectClick = (path) => {
        navigate(path);
    };

    if (loading) {
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: '#f9fafb'
            }}>
                <div style={{ textAlign: 'center' }}>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        border: '4px solid #3b82f6',
                        borderTopColor: 'transparent',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        margin: '0 auto'
                    }}></div>
                    <p style={{ marginTop: '16px', fontSize: '1.1rem', color: '#4b5563' }}>
                        Loading your dashboard...
                    </p>
                </div>
            </div>
        );
    }

    return (
        <div style={{
            minHeight: '100vh',
            background: 'linear-gradient(to bottom right, #f9fafb, #f3f4f6)',
            paddingBottom: '60px',
            overflowX: 'hidden'   // ← Important for mobile
        }}>
            {/* Greeting Header */}
            <div style={{
                backgroundColor: 'white',
                boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
                borderBottom: '1px solid #f3f4f6',
                padding: '28px 20px'
            }}>
                <div style={{ maxWidth: '1280px', margin: '0 auto' }}>
                    <h1 style={{
                        fontSize: '1.85rem',
                        fontWeight: '700',
                        color: '#111827',
                        letterSpacing: '-0.025em',
                        lineHeight: '1.2'
                    }}>
                        {welcomeMessage}
                    </h1>
                    <p style={{
                        marginTop: '10px',
                        fontSize: '1.05rem',
                        color: '#4b5563'
                    }}>
                        आज तपाईं के सिख्नु चाहनुहुन्छ?
                    </p>
                </div>
            </div>

            {/* Subjects Section */}
            <div style={{ 
                maxWidth: '1280px', 
                margin: '0 auto', 
                padding: '32px 20px' 
            }}>
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '28px',
                    flexWrap: 'wrap',
                    gap: '8px'
                }}>
                    <h2 style={{
                        fontSize: '1.65rem',
                        fontWeight: '600',
                        color: '#1f2937'
                    }}>
                        आफ्नो विषय छान्नुहोस्
                    </h2>
                    <p style={{ 
                        fontSize: '0.875rem', 
                        color: '#6b7280',
                        whiteSpace: 'nowrap'
                    }}>
                        Tap to start learning
                    </p>
                </div>

                {/* Responsive Subjects Grid */}
                <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
                    gap: '24px',
                }}>
                    {subjects.map((subject, index) => (
                        <div
                            key={index}
                            style={{
                                backgroundColor: 'white',
                                borderRadius: '20px',
                                padding: '28px 20px',
                                border: `2px solid ${subject.color}`,
                                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                transition: 'all 0.3s ease',
                                cursor: 'pointer',
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                textAlign: 'center',
                                minHeight: '360px',
                            }}
                            onClick={() => handleSubjectClick(subject.path)}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-6px)';
                                e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(0, 0, 0, 0.1)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = '0 4px 6px -1px rgba(0, 0, 0, 0.1)';
                            }}
                        >
                            {/* Icon */}
                            <div style={{
                                width: '100px',
                                height: '100px',
                                backgroundColor: subject.bgColor,
                                borderRadius: '16px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginBottom: '24px',
                            }}>
                                <img
                                    src={subject.icon}
                                    alt={subject.title}
                                    style={{
                                        width: '68px',
                                        height: '68px',
                                        objectFit: 'contain',
                                    }}
                                />
                            </div>

                            <h3 style={{
                                fontSize: '1.55rem',
                                fontWeight: '600',
                                color: '#1f2937',
                                marginBottom: '12px',
                                minHeight: '48px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                {subject.title}
                            </h3>

                            <p style={{
                                color: '#6b7280',
                                fontSize: '0.95rem',
                                lineHeight: '1.5',
                                flex: 1,
                                marginBottom: '24px',
                            }}>
                                {   subject.title.toLowerCase() === 'mathematics' 
                                    ? "teaches that every problem of our life has a solution"
                                    : subject.title.toLowerCase() === 'general knowledge' 
                                    ? "is not just about facts; it is the power of knowledge"
                                    : subject.title.toLowerCase() === 'mental ability' 
                                    ? "says, our ability depends on thinking power, rather than bookish knowledge"
                                    : subject.title.toLowerCase() === 'english' 
                                    ? "is the thread that connects diverse Indians into a single necklace" 
                                    : ""}
                            </p>

                            <div style={{
                                marginTop: 'auto',
                                height: '6px',
                                width: '52px',
                                backgroundColor: subject.color,
                                borderRadius: '9999px',
                                opacity: '0.3',
                            }}/>
                        </div>
                    ))}
                </div>
            </div>

            {/* Motivation Bar */}
            <div style={{ 
                maxWidth: '1280px', 
                margin: '0 auto', 
                padding: '0 20px' 
            }}>
                <div style={{
                    backgroundColor: 'white',
                    borderRadius: '20px',
                    padding: '28px 24px',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                    border: '1px solid #f3f4f6',
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '16px'
                }}>
                    <div style={{ fontSize: '2.6rem', flexShrink: 0 }}>🚀</div>
                    <div>
                        <p style={{ 
                            fontWeight: '600', 
                            color: '#374151', 
                            marginBottom: '8px', 
                            fontSize: '1.1rem',
                            lineHeight: '1.3'
                        }}>
                            Yes, You can achieve the goal!
                        </p>
                        <p style={{ 
                            fontSize: '0.95rem', 
                            color: '#6b7280', 
                            lineHeight: '1.55' 
                        }}>
                            सफलता निरन्तरता, समर्पण र हरेक दिन काम गर्ने अनुशासनमा निर्भर गर्दछ
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;